"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfFontInfo = void 0;
var constants_1 = require("@devexpress/utils/lib/constants");
var RtfFontInfo = (function () {
    function RtfFontInfo() {
        this.charset = -1;
        this.name = "";
        this._shouldLoad = false;
    }
    Object.defineProperty(RtfFontInfo.prototype, "shouldLoad", {
        get: function () { return this._shouldLoad; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfFontInfo.prototype, "cachedInfo", {
        get: function () { return this._cachedInfo; },
        enumerable: false,
        configurable: true
    });
    RtfFontInfo.prototype.getCoreObjectByName = function (documentModel) {
        if (this._cachedInfo)
            return this._cachedInfo;
        this._cachedInfo = documentModel.cache.fontInfoCache.getItemByName(this.name);
        if (!this._cachedInfo) {
            this._shouldLoad = true;
            this._cachedInfo = documentModel.cache.fontInfoCache.addFont(this.name, this.name);
        }
        return this._cachedInfo;
    };
    RtfFontInfo.createDefaultRtfFontInfo = function () {
        var info = new RtfFontInfo();
        info.name = "Times New Roman";
        info.id = constants_1.Constants.MAX_SAFE_INTEGER;
        return info;
    };
    RtfFontInfo.getFontInfo = function (fontInfoCache, name) {
        var fontInfo = fontInfoCache.getItemByName(name);
        return fontInfo ? fontInfo : fontInfoCache.addFont(name, name);
    };
    return RtfFontInfo;
}());
exports.RtfFontInfo = RtfFontInfo;
